import { AuthGuard } from '@core/auth';
import { RouteEnum } from '@core/models';
import { Routes } from '@angular/router';
import { V0_Pages } from '@client-v0/index';

export const routes: Routes = [
  {
    path: '',
    redirectTo: RouteEnum.DASHBOARD,
    pathMatch: 'full',
  },
  {
    path: RouteEnum.DASHBOARD,
    loadComponent: () =>
      import('@client-v0/pages/dashboard/dashboard.component').then(
        (c) => c.DashboardComponent
      ),
  },
  {
    path: RouteEnum.OIDC_TOKENS,
    component: V0_Pages.InspectTokensComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RouteEnum.CREATE_KEYS,
    component: V0_Pages.CreateKeyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RouteEnum.API_TESTER,
    component: V0_Pages.ApiTesterComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RouteEnum.INTROSPECT_KEY,
    component: V0_Pages.IntrospectKeyComponent,
    canActivate: [AuthGuard],
  },
];
